import React, { useEffect, useState } from 'react'
import { ClickAwayListener } from '@mui/material'
import { useDispatch } from 'react-redux'
import { StyledTextField, StyledBoxWrapper } from './styles'
import CreateQuestionCardDropDownMenu from '../CreateQuestionCardWrapper/CreateQuestionCardDropDownMenu'
import { type DescriptiveQuestion, SurveyItemQuestionType } from '../../../types'
import { addSurveyQuestionInSection, deleteQuestionFromSection, type ISurveySection, setSelectedQuestion, updateQuestionInSection } from '../../../../../store/slices/SurveyTemplateSlice'
import { getEditableQuestion } from '../../../../../store/slices/SurveyTemplateSlice/selectors'
import { v4 as uuidv4 } from 'uuid'

interface CreateDescriptiveQuestionCardProps {
  sectionIndex?: number
  questionIndex?: number
  section: ISurveySection
}

const CreateDescriptiveQuestionCard: React.FC<CreateDescriptiveQuestionCardProps> = ({ sectionIndex = 0, questionIndex = 0, section }): JSX.Element => {
  const dispatch = useDispatch()
  const editableQuestion = getEditableQuestion()

  const [descriptiveCardData, setDescriptiveCardData] = useState<DescriptiveQuestion>({
    itemId: uuidv4(),
    itemType: SurveyItemQuestionType.DESCRIPTIVE_TEXT,
    prompt: '',
    isRequired: false,
    branchingFilters: null
  })

  useEffect(() => {
    if (editableQuestion != null) {
      setDescriptiveCardData(editableQuestion.question as DescriptiveQuestion)
    }
  }, [editableQuestion])

  const handleQuestionTitle = (questionTitle: string): void => {
    setDescriptiveCardData(prevState => {
      return { ...prevState, prompt: questionTitle }
    })
  }

  const handleDelete = (): void => {
    if (editableQuestion != null) {
      dispatch(deleteQuestionFromSection({ surveySectionId: section.surveySectionId, questionIndex }))
      return
    }
    dispatch(setSelectedQuestion(null))
  }

  const handleClickAway = (): void => {
    if (editableQuestion) {
      dispatch(updateQuestionInSection({ surveySectionId: section.surveySectionId, questionIndex, updatedQuestion: descriptiveCardData }))
      return
    }

    dispatch(addSurveyQuestionInSection({ surveySectionId: section.surveySectionId, question: descriptiveCardData }))

    dispatch(setSelectedQuestion(null))
  }

  return (
    <ClickAwayListener
      mouseEvent="onMouseDown"
      touchEvent="onTouchStart"
      onClickAway={handleClickAway}>
      <StyledBoxWrapper >
        <StyledTextField type='text' value={descriptiveCardData?.prompt} placeholder='Add text here...' autoFocus onChange={(e) => { handleQuestionTitle(e.target.value) }} fullWidth />
        <CreateQuestionCardDropDownMenu handleDelete={handleDelete} />
      </StyledBoxWrapper>
    </ClickAwayListener >

  )
}

export default CreateDescriptiveQuestionCard
